// Copyright (c) 2021 Deere & Company

import DealerHierarchyLeadAccount from './dealer-hierarchy-lead-account';
import t from 'tcomb';

const DealerLocationHierarchy = t.list(DealerHierarchyLeadAccount, 'DealerLocationHierarchy');

export const getDefaultState = () => new DealerLocationHierarchy([]);

export default DealerLocationHierarchy;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-location-hierarchy.js